module.exports = __webpack_public_path__ + "static/media/paypal.54680cbb.png";